import initReactFastclick from './fastclick';
import injectScriptsFn from './inject-scripts';
import shimFn from './shim';

export const fastclick = {
  enable: false,
  run: initReactFastclick
};

export const injectScripts = {
  enable: true,
  run: injectScriptsFn
};

export const shim = {
  enable: true,
  run: shimFn
};



// WEBPACK FOOTER //
// ./src/initialize/configs.js